<div class="ui modal"
     id="Transactions_Modal">


  <div class="transaction-modal-container">

    <div class="transactions-modal-header">
      <div class="title">
      <span>
        {{"Welcome" | t}} {{this.coreService.customerUser?.UserName}}
      </span>
      </div>
      <div class="close"
           (click)="modalHide()">
        <i class="close icon"></i>
      </div>
    </div>

    <div class="transactions-modal-row mt-25">
      <div class="left">
        <span>
          {{"Transactions_Modal_Current_Account_Balance" | t}}
        </span>
      </div>
      <div class="right">
        {{Balance | number : '1.2-2'}} {{this.coreService.customerUser?.Symbol}}
      </div>
    </div>

    <div class="transactions-modal-row">
      <div class="left">
        <span>
          {{"Transactions_Modal_Bonus" | t}}
        </span>
      </div>
      <div class="right">
        {{Bonus | number : '1.2-2'}} {{this.coreService.customerUser?.Symbol}}
      </div>
    </div>

    <div class="transactions-modal-row">
      <div class="left">
        <span>
          {{"Transactions_Modal_Deposit" | t}}
        </span>
      </div>
      <div class="right">
        {{Deposit | number : '1.2-2'}} {{this.coreService.customerUser?.Symbol}}
      </div>
    </div>

    <div class="transactions-modal-row">
      <div class="left">
        <span>
          {{"Transactions_Modal_Withdraw" | t}}
        </span>
      </div>
      <div class="right">
        {{Withdraw | number : '1.2-2'}} {{this.coreService.customerUser?.Symbol}}
      </div>
    </div>

    <div class="transactions-modal-row">
      <div class="left">
        <span>
          {{"Transactions_Modal_Open_Bets" | t}}
        </span>
      </div>
      <div class="right">
        {{OpenCount}}
      </div>
    </div>


    <div class="transactions-modal-row title mt-25">
      <span>
          {{"Transactions_Modal_Subtitle" | t}}
      </span>
    </div>

    <div class="transactions-modal-row">
      <div class="left">
        <span>
          {{"Transactions_Modal_WinAmount" | t}}
        </span>
      </div>
      <div class="right">
        {{WinAmount | number : '1.2-2'}} {{this.coreService.customerUser?.Symbol}}
      </div>
    </div>

    <div class="transactions-modal-row">
      <div class="left">
        <span>
          {{"Transactions_Modal_Lost_Amount" | t}}
        </span>
      </div>
      <div class="right">
        {{LostAmount | number : '1.2-2'}} {{this.coreService.customerUser?.Symbol}}
      </div>
    </div>

    <div class="transactions-modal-row">
      <div class="left bold">
        <span>
          {{"Transactions_Modal_Profit_Loss" | t}}
        </span>
      </div>
      <div class="right bold">
        {{TotalBet | number : '1.2-2'}} {{this.coreService.customerUser?.Symbol}}
      </div>
    </div>

    <div class="transaction-modal-table mt-25">
      <div class="transaction-modal-table-header">
        <div class="left bold">
          <span>
            {{"Transactions_Modal_Date_Time" | t}}
          </span>
        </div>
        <div class="mid bold">
          <span>
            {{"Transactions_Modal_Description" | t}}
          </span>
        </div>
        <div class="right bold">
          <span>
            {{"Transactions_Modal_Amount" | t}}
          </span>
        </div>
      </div>

      <div class="transaction-modal-table-content">
        <div class="transaction-modal-table-row"
             *ngFor="let item of this.bookingsList | sortBy: true: 'TransactionDateISO'; let i = index;"
             [ngClass]="{'table-row-alternative' : i%2==1}">
          <div class="left">
            {{
            item.TransactionDateISO | date : 'dd.MM.yyyy'
            }}
          </div>
          <div class="mid">
            {{item.TransactionType}}
          </div>
          <div class="right">
            {{item.Amount}} {{item.Currency}}
          </div>
        </div>
      </div>

    </div>

  </div>


</div>
